<template>
  <el-dialog
    :title="isCreate ? '新增优惠券' : '编辑优惠券'"
    :visible="true"
    width="60%"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="优惠券名称" prop="couponName">
            <el-input v-model.trim="ruleForm.couponName" type="text"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="优惠券类型">
            <el-select v-model="ruleForm.type" placeholder="请选择优惠券类型">
              <el-option
                v-for="(item, index) in Coupon.typeList()"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8" v-if="ruleForm.type === 2 || ruleForm.type === 3">
          <el-form-item label="折扣率(%)" prop="zhekou">
            <el-input-number
              v-model.trim="ruleForm.zhekou"
              :step="5"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="ruleForm.type === 1">
          <el-form-item label="抵价金额" prop="discountAmount">
            <el-input
              v-model.trim="ruleForm.discountAmount"
              type="text"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="优惠券产品">
            <el-select
              v-model="ruleForm.limitedProductType"
              placeholder="请选择优惠券产品"
            >
              <el-option
                v-for="(item, index) in Coupon.limitedProductTypeList()"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="优惠券总数" prop="count">
            <el-input v-model.trim="ruleForm.count" type="text"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最多领用数(0表示不限制)" prop="keepNumber">
            <el-input v-model.trim="ruleForm.keepNumber" type="text"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="8">
          <el-form-item label="最少生效金额" prop="minimalAmount">
            <el-input
              v-model.trim="ruleForm.minimalAmount"
              type="text"
            ></el-input>
          </el-form-item>
        </el-col>-->
        <el-col :span="4">
          <el-form-item label="是否有效">
            <el-switch v-model="ruleForm.isEnable"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="全局" v-if="userType === 'admin'">
            <el-switch
              v-model="ruleForm.isGlobal"
              @change="changeGlobal"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="10" v-if="userType === 'admin'">
          <el-form-item label="加盟商" prop="vendorid">
            <!-- <el-select
              v-model="ruleForm.vendorid"
              placeholder="请选择"
              @change="handleChangeVendor"
            >
              <el-option
                v-for="(item, index) in vendorsList"
                :key="index"
                :label="item.vendorName"
                :value="item.vendorid"
              ></el-option>
            </el-select> -->
            <el-autocomplete
              v-model="ruleForm.vendorName"
              :fetch-suggestions="querySearchVendor"
              placeholder="请输入加盟商"
              :disabled="this.ruleForm.isGlobal"
            ></el-autocomplete>
            {{ ruleForm.vendorid }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="门店" prop="shopids">
            <el-select
              v-model="ruleForm.shopids"
              @change="$forceUpdate()"
              :disabled="this.ruleForm.isGlobal"
              multiple
              value-key="shopid"
            >
              <el-option
                v-for="item in shopListForPrompt"
                :key="item.shopid"
                :label="item.value"
                :value="item.shopid"
              ></el-option>
            </el-select>
            <el-checkbox
              v-model="allChecked"
              :disabled="
                this.ruleForm.isGlobal || shopListForPrompt.length === 0
              "
              @change="handleChangeAllChecked"
              >全选</el-checkbox
            >
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="使用时间段" prop="dateRange">
            <el-date-picker
              v-model="ruleForm.dateRange"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :rows="3"
              v-model.trim="ruleForm.remark"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
//import { mapGetters } from "vuex";
import Coupon from "../../../plugins/CouponClass";
export default {
  props: ["isCreate", "couponItem"],
  data() {
    const couponObj = this.isCreate ? new Coupon() : this.couponItem;
    if (!this.isCreate) {
      let list = [];
      if (this.couponItem.shops && this.couponItem.shops.length) {
        this.couponItem.shops.forEach(ele => {
          list = list.concat(Object.keys(ele));
        });
        couponObj.shopids = list;
      }
    }
    return {
      // vendorsList: [],
      // shopList: [],
      vendorListForPrompt: [],
      shopListForPrompt: [],
      ruleForm: {
        vendorName: "",
        isGlobal: false,
        ...couponObj,
        dateRange: this.isCreate
          ? ""
          : [this.couponItem.startDate, this.couponItem.expireDate]
      },
      rules: {
        couponName: [{ required: true, message: "请输入优惠券名称" }],
        zhekou: [
          { required: true, message: "请输入折扣率百分比" },
          {
            pattern: /^(0|[1-9]\d?|100)$/,
            message: "请输入正确的数字"
          }
        ],
        discountAmount: [
          { required: true, message: "请输入抵价券数额" },
          {
            pattern: /^(\d*\.\d+|\d*)$/,
            message: "请输入正确的数字"
          }
        ],
        count: [
          { required: true, message: "请输入优惠券总数" },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: "请输入正确的数字"
          }
        ],
        minimalAmount: [
          { required: true, message: "请输入最少生效金额" },
          {
            pattern: /^\d{0,}(\.\d{1,2})?$/,
            message: "请输入正确的数字"
          }
        ],
        keepNumber: [
          { required: true, message: "请输入最多领用数" },
          {
            pattern: /^\d{0,}(\.\d{1,2})?$/,
            message: "请输入正确的数字"
          }
        ],
        vendorid: [{ required: true, message: "请输入加盟商" }],
        dateRange: [{ required: true, message: "请输入时间段" }],
        shopids: [{ required: true, message: "请输入门店" }],
        remark: [{ required: true, message: "请输入备注" }]
      },
      Coupon,
      allChecked: false,
      userType: this.$getUserType()
    };
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.$axios(
            this.$urlMapping[this.isCreate ? "新增优惠券" : "更新优惠券"],
            {
              data: {
                id: this.isCreate ? undefined : this.ruleForm.id,
                couponid: this.isCreate ? undefined : this.ruleForm.couponid,
                couponName: this.ruleForm.couponName,
                type: this.ruleForm.type,
                limitedProductType: this.ruleForm.limitedProductType,
                zhekou: this.ruleForm.zhekou,
                discountAmount: this.ruleForm.discountAmount,
                keepNumber: this.ruleForm.keepNumber,
                count: this.ruleForm.count,
                minimalAmount: this.ruleForm.minimalAmount,
                isEnable: this.ruleForm.isEnable,
                vendorid: this.ruleForm.vendorid,
                shopids: this.ruleForm.shopids,
                remark: this.ruleForm.remark,
                startDate: Array.isArray(this.ruleForm.dateRange)
                  ? this.$ToDateTimeString(this.ruleForm.dateRange[0])
                  : null,
                expireDate: Array.isArray(this.ruleForm.dateRange)
                  ? this.$ToDateTimeString(this.ruleForm.dateRange[1])
                  : null
              }
            }
          ).then(() => {
            this.closeForm();
            this.$emit("refreshData");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    },
    handleChangeAllChecked() {
      if (this.allChecked) {
        this.ruleForm.shopids = this.shopListForPrompt.map(ele => ele.shopid);
      } else {
        this.ruleForm.shopids = [];
      }
    },
    changeGlobal(e) {
      this.ruleForm.isGlobal = e;
      if (e == true) {
        //this.ruleForm.vendorName = "global";
        this.ruleForm.vendorid = "global";
        this.ruleForm.shopids = ["global"];
      } else {
        this.ruleForm.vendorName = "";
        this.ruleForm.vendorid = "";
        this.ruleForm.shopids = [];
      }
      console.log(this.ruleForm.vendorid);
      console.log(this.ruleForm.shopids);
    },
    querySearchVendor(queryString, cb) {
      let results = queryString
        ? this.vendorListForPrompt.filter(this.$createFilter(queryString))
        : this.vendorListForPrompt;
      // 调用 callback 返回建议列表的数据
      cb(results);
    }
  },

  watch: {
    "ruleForm.vendorName": {
      handler(newName, oldName) {
        if (newName != oldName) {
          //console.log("vendorName changed" + newName + oldName);
          this.ruleForm.vendorid = this.$getVendorID(newName);

          if (this.ruleForm.vendorid) {
            //this.queryShopForPrompt();
            this.$queryShopForPrompt(this.ruleForm.vendorid, result => {
              this.shopListForPrompt = result;
            });
          } else {
            this.shopListForPrompt = [];
            this.ruleForm.shopids = [];
            //this.$refs["vendor_select"].reset();
          }
        }
      }
    },

    "ruleForm.shopids": {
      handler: function(val) {
        if (val.length === 0 || val.length < this.shopListForPrompt.length) {
          this.allChecked = false;
        }
      }
    }
  },
  async mounted() {
    if (this.userType === "admin") {
      this.$queryVendorForPrompt(null, result => {
        this.vendorListForPrompt = result;
      });
    }
    if (!this.isCreate) {
      if (this.ruleForm.vendorid != "global") {
        //不是全局优惠券
        this.ruleForm.vendorName = this.$getVendorName(this.ruleForm.vendorid);
      } else {
        //全局优惠券
        this.ruleForm.isGlobal = true;
        this.ruleForm.shopids = ["global"];
      }
    }

    // await this.$axios(this.$urlMapping["查询门店"], {
    //   data: {}
    // }).then(result => {
    //   this.shopList = result.data;
    // });
  }
};
</script>

<style lang="less" scoped></style>
